/** The top of the Schedules section: how the section is used. */
export function SchedulesIntro() {
  return (
    <p className="mb-2 text-sm text-muted-foreground">
      Add (or remove) tables to sync to recurring schedules in sections below.
    </p>
  );
}
